<template>
    <b-modal title="Adjust Stock" id="stockAdjustmentModal" size="md" hide-footer>
        <b-overlay :show="busySaving">
            <b-form @submit.prevent="handleSubmit">
                <div class="mb-3 text-center">
                    <stock-badge
                        :quantity="currentStock"
                        :low-threshold="lowThreshold"
                        :show-in-stock="true"
                    />
                    <h4 class="mt-2">Current Stock: {{ currentStock }}</h4>
                    <p class="text-muted mb-0">{{ productName }}</p>
                </div>

                <hr />

                <b-row>
                    <b-col>
                        <label class="mb-0">Adjustment:</label>
                        <b-form-input
                            v-model.number="adjustment"
                            size="sm"
                            type="number"
                            required
                            placeholder="e.g. 10 or -5"
                        ></b-form-input>
                        <small class="text-muted">
                            Positive to add stock, negative to remove.
                        </small>
                    </b-col>
                </b-row>

                <b-row class="mt-2" v-if="adjustment !== 0 && adjustment !== '' && adjustment !== null">
                    <b-col>
                        <div class="text-center">
                            <small>
                                New stock will be:
                                <strong :class="newStockClass">{{ newStock }}</strong>
                            </small>
                        </div>
                    </b-col>
                </b-row>

                <b-row class="mt-3">
                    <b-col>
                        <label class="mb-0">Reason: <span class="text-danger">*</span></label>
                        <b-form-textarea
                            v-model="reason"
                            size="sm"
                            required
                            maxlength="500"
                            placeholder="e.g. Delivery received, stocktake correction..."
                            rows="2"
                        ></b-form-textarea>
                    </b-col>
                </b-row>

                <div class="modal-footer">
                    <b-button type="submit" variant="primary" :disabled="!isValid">Adjust Stock</b-button>
                    <button type="button" class="btn btn-secondary" @click="hideModal()">Cancel</button>
                </div>
            </b-form>
        </b-overlay>
    </b-modal>
</template>

<script>
import { productMethods, productComputed } from "@/state/helpers";
import stockBadge from "@/components/shared/stockBadge.vue";

export default {
    components: { stockBadge },
    props: {
        product_id: {
            required: true,
        },
    },
    data: () => ({
        adjustment: null,
        reason: '',
        busySaving: false,
        productName: '',
        currentStock: 0,
        lowThreshold: 5,
    }),
    computed: {
        ...productComputed,
        newStock() {
            return this.currentStock + (this.adjustment || 0);
        },
        newStockClass() {
            if (this.newStock < 0) return 'text-danger';
            if (this.newStock <= this.lowThreshold) return 'text-warning';
            return 'text-success';
        },
        isValid() {
            return this.adjustment !== 0 &&
                   this.adjustment !== null &&
                   this.adjustment !== '' &&
                   this.newStock >= 0 &&
                   this.reason.trim().length > 0;
        },
    },
    methods: {
        ...productMethods,
        handleSubmit() {
            if (!this.isValid) return;
            this.busySaving = true;
            this.adjustStock({
                product_id: this.product_id,
                adjustment: this.adjustment,
                reason: this.reason,
            }).then(() => {
                this.getProducts().then(() => {
                    this.busySaving = false;
                    this.hideModal();
                    this.$swal.fire(
                        "Stock Updated",
                        `Stock adjusted by ${this.adjustment > 0 ? '+' : ''}${this.adjustment} for ${this.productName}`,
                        "success"
                    );
                });
            }).catch((error) => {
                this.busySaving = false;
                const msg = error && error.response && error.response.data && error.response.data.error
                    ? error.response.data.error
                    : 'Failed to adjust stock';
                this.$swal.fire("Error", msg, "error");
            });
        },
        hideModal() {
            this.$bvModal.hide("stockAdjustmentModal");
        },
    },
    mounted() {
        let product = this.all_products.find(item => item.id == this.product_id);
        if (product) {
            this.productName = product.name;
            this.currentStock = product.stock_quantity || 0;
            this.lowThreshold = product.low_stock_threshold || 5;
        }
    },
};
</script>
